import React from "react";
import KVSlide from "./KVSlide.js"
import Event from "./Event.js"
import Investor from "./Investor.js"
import PR from "./PR.js"
import Milestone from "./Milestone.js"
import Performance from "./Performance.js"
import Group from "./Group.js"
import ImagePopup from "./ImagePopup.js"
import VideoSec from "./VideoSec.js"
import FtcTeam from "./FtcTeam.js"
import Partner from "./Partner.js"


const Index = (props) => {
	return(
		<div className="Index_ctnr">
			<KVSlide />
			<Event />

			<PR />
			<Milestone />
			<Performance />
			<Group />
			<ImagePopup />
			<VideoSec />
			<FtcTeam />
			<Partner />
		</div>
	)
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/index/Index.js